const DITypes = {
  SocketProcessingAdapter: Symbol('FinsightSocketProcessingAdapter'),
  UploadDispatcher: Symbol('FinsightUploadDispatcher'),
  UploadAdapter: Symbol('FinsightUploadAdapter'),
};

export default DITypes;
